<template>
    <div>
  

        <el-form ref="form" :model="form" label-width="80px">

  <el-form-item label="标题">
    <el-input v-model="form.title"></el-input>
  </el-form-item>



  <el-form-item label="内容">
    <el-input type="textarea" v-model="form.content"  :autosize="{ minRows: 6, maxRows: 10}"></el-input>
  </el-form-item>
  <el-form-item>
    <el-button type="primary" @click="onSubmit">新增日志</el-button>

  </el-form-item>
</el-form>


  
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        form: {
          title: '',
          content: '',
        }
      }
    },
    methods: {
      onSubmit() {

        //console.log('submit!');
        this.$http.post("/v1/new_dev_log",this.form).then( (response)=>  { 
          location.reload();
      })





      }
    }
  }
</script>
 
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  